// AUTO-GENERATED by tools/design-tokens/generate-css-refs.ts -- do not edit.
// Regenerate: npm run generate:derived-artifacts (or any typecheck/vitest run -- both ensure it)

/** Spacing tokens (4px base unit) */
export const spacing = {
	"0": "var(--space-0)",
	"1": "var(--space-1)",
	"2": "var(--space-2)",
	"3": "var(--space-3)",
	"4": "var(--space-4)",
	"5": "var(--space-5)",
	"6": "var(--space-6)",
	"7": "var(--space-7)",
	"8": "var(--space-8)",
	"9": "var(--space-9)",
	"10": "var(--space-10)",
	"11": "var(--space-11)",
	"12": "var(--space-12)",
	"14": "var(--space-14)",
	"15": "var(--space-15)",
	"16": "var(--space-16)",
	"18": "var(--space-18)",
	"20": "var(--space-20)",
	"24": "var(--space-24)",
	"25": "var(--space-25)",
	"30": "var(--space-30)",
	"32": "var(--space-32)",
	"35": "var(--space-35)",
	"40": "var(--space-40)",
	"44": "var(--space-44)",
	"45": "var(--space-45)",
	"48": "var(--space-48)",
	"50": "var(--space-50)",
	"60": "var(--space-60)",
	"70": "var(--space-70)",
	"75": "var(--space-75)",
	"80": "var(--space-80)",
	"90": "var(--space-90)",
	"96": "var(--space-96)",
	"100": "var(--space-100)",
	"105": "var(--space-105)",
	"120": "var(--space-120)",
	"125": "var(--space-125)",
	"150": "var(--space-150)",
	"175": "var(--space-175)",
	"200": "var(--space-200)",
	"225": "var(--space-225)",
	"300": "var(--space-300)",
	"350": "var(--space-350)",
	"0.25": "var(--space-0-25)",
	"0.5": "var(--space-0-5)",
	"0.75": "var(--space-0-75)",
	"1.25": "var(--space-1-25)",
	"1.5": "var(--space-1-5)",
	"2.5": "var(--space-2-5)",
	"3.5": "var(--space-3-5)",
	"4.5": "var(--space-4-5)",
	"37.5": "var(--space-37-5)",
	"62.5": "var(--space-62-5)",
	"212.5": "var(--space-212-5)",
	xxs: "var(--space-xxs)",
	xs: "var(--space-xs)",
	sm: "var(--space-sm)",
	md: "var(--space-md)",
	lg: "var(--space-lg)",
	xl: "var(--space-xl)",
	contextual: {
		sectionToSection: "var(--space-contextual-section-to-section)",
		relatedItems: "var(--space-contextual-related-items)",
		cardPadding: "var(--space-contextual-card-padding)",
		viewportPreload: "var(--space-contextual-viewport-preload)",
	},
} as const;

/** Breakpoint tokens */
export const breakpoints = {
	mobileMax: "var(--breakpoint-mobile-max)",
	tabletMax: "var(--breakpoint-tablet-max)",
	sm: "var(--breakpoint-sm)",
	md: "var(--breakpoint-md)",
	lg: "var(--breakpoint-lg)",
	xl: "var(--breakpoint-xl)",
	"2xl": "var(--breakpoint-2xl)",
} as const;
